import { create } from "zustand";

export enum PendingUpdateType {
  SESSION_ESCALATION = "session-session",
  TAKING_OVER_ON_CHANNEL = "taking-over-on-channel",
  USER_ARCHIVED_STATE = "user-archive-state",
  NOTIFICATION_ACKNOWLEDGED = "notification-acknowledged",
}
interface StoreInterface {
  pendingUpdates: { [keyPath: string]: { type: PendingUpdateType; data?: any } };
}
const BlankState: StoreInterface = {
  pendingUpdates: {},
};

export default class PendingUpdatesModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = PendingUpdatesModel.useState.setState;
  static get state() {
    return PendingUpdatesModel.useState.getState();
  }
  static reset() {
    PendingUpdatesModel.setState({ ...BlankState });
  }
  static addPendingUpdate(type: PendingUpdateType, id: number | string, data?: any) {
    const currentUpdates = { ...PendingUpdatesModel.state.pendingUpdates };
    currentUpdates[PendingUpdatesModel.keyForUpdate(type, id)] = { type, data };
    PendingUpdatesModel.setState({ pendingUpdates: currentUpdates });
  }

  static removePendingUpdate(type: PendingUpdateType, id: number | string) {
    const currentUpdates = { ...PendingUpdatesModel.state.pendingUpdates };
    delete currentUpdates[PendingUpdatesModel.keyForUpdate(type, id)];
    PendingUpdatesModel.setState({ pendingUpdates: currentUpdates });
  }

  static keyForUpdate(type: PendingUpdateType, id: number | string) {
    return `${type}:${id}`;
  }

  static hasPendingUpdate(updateTypes?: { type: PendingUpdateType; id: number | string }[]): boolean {
    if (!updateTypes || updateTypes.length === 0) {
      return false;
    }
    const pendingUpdates = PendingUpdatesModel.state.pendingUpdates || {};
    return updateTypes.some((update) => pendingUpdates[PendingUpdatesModel.keyForUpdate(update.type, update.id)]);
  }
}
